import { createApi } from '@reduxjs/toolkit/query/react';

import { getData } from '../../services/API';
import { sasTokenUrl } from '../../services/API/endpoints';

import { processError } from './utils/transformations';
import { date } from '../../utils/helpers';

interface ITokenData {
  sasToken: string;
  tokenExpirationDateInUTC: string;
}

/**
 * RTK Query API slice for patient features.
 *
 * @remarks
 * Provides endpoints for:
 * - SAS token retrieval (`getSassToken`)
 *
 * @example
 * import { useGetSassTokenQuery } from 'src/redux/apis/Patients.api';
 * const { data } = useGetSassTokenQuery();
 */
export const sassApi = createApi({
  reducerPath: 'sassApi',
  baseQuery: (operation: any) => operation,
  tagTypes: ['sass-token'],
  invalidationBehavior: 'immediately',
  endpoints: builder => ({
    getSassToken: builder.query<ITokenData, void>({
      query: () => getData(sasTokenUrl, {}),
      transformResponse: response => ({
        ...response,
        sasToken: `${response.sasToken}&${Date.now()}`
      }),
      transformErrorResponse: processError,
      providesTags: ['sass-token'],
      forceRefetch: ({ state }: any) =>
        date.now() > state.ConfigReducer.tokenExpiry
    })
  })
});

export const { useGetSassTokenQuery, useLazyGetSassTokenQuery } = sassApi;
